import React, { useEffect, useRef, useState } from 'react';
import UserRegistration from './userregistration';
import helperfunctions from '../../utils/helperfunctions';
import userServices from '../../services/userservices';
import Bowser from "bowser";
import { useSearchParams } from 'react-router-dom';

const UserRegistrationContainer = () => {

    const [errorSuccessMessage, setErrorSuccessMessage] = useState('');
    const [isShowReqError, setIsShowReqError] = useState(false);
    const [submitResponse, setSubmitResponse] = useState<any>({ loading: false, data: {} });
    const [countryFromZipRes, setCountryFromZipRes] = useState<any>({ loading: false, data: {} });
    const [showDistributorAvailabilityPopUp, setShowDistributorAvailabilityPopUp] = useState(false);
    const [checkDistAvailabilityRes, setCheckDistAvailabilityRes] = useState<any>({ loading: false, data: [] });
    const [addressList, setAddressList] = useState<any>({ loading: false, data: [] });
    const [selectedAddress, setSelectedAddress] = useState<any>('');
    const [changeDistPopup, setChangeDistPopup] = useState(false);
    const [formData, setFormData] = useState<any>({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        jobTitle: '',
        companyName: '',
        city: '',
        zip: '',
        address: '',
        state: '',
        country: 'United States of America',
        countryCode: 'US',
        modalNumber: '',
        distributor: '',
        serialNumber: '',
        isAgreeTerms: false,
        isSendInvitation: false,
    });
    const [selectedModel, setSelectedModel] = useState<any>({});
    const [searchParams] = useSearchParams();
    const applicationName = searchParams.get("applicationname") ?? ''
    const isKacApp = applicationName.toUpperCase() === 'KAC-SCMP';
    const redirecturl = searchParams.get("redirecturl") ?? '';

    const [errors, setErrors] = useState<any>({
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        jobTitle: false,
        companyName: false,
        city: false,
        zip: false,
        address: false,
        state: false,
        country: false,
        modalNumber: false,
        distributor: false,
        isAgreeTerms: false,
        isValidEmail: false,
        isValidPhone: false,
        serialNumber: false,
    });

    const [countryOptions, setCountryOptions] = useState<any>({ loading: false, data: [] });
    const [stateOptions, setStateOptions] = useState<any>({ loading: false, data: [] });
    const [modalNumberList, setModalNumberList] = useState<any>({ loading: false, data: [] });
    const [distributorList, setDistributorList] = useState<any>({ loading: false, data: [] });
    const [jobTitleList, setJobTitleList] = useState<any>({ loading: false, data: [] });
    const [selectedDistBeforeConfirm, setSelectedDistBeforeConfirm] = useState<any>({});
    const [clientInfo, setClientInfo] = useState<any>({});
    const [myKomastuBaseUrl, setMyKomastuBaseUrl] = useState<string>("");
    const [submitAlert, setSubmitAlert] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [notificationResponse, setNotificationResponse] = useState<any>({ loading: false, isSuccess: '' });
    const [closeConfirmation, setCloseConfirmation] = useState(false);
    const [socialMediaChannelLink, setSocialMediaChannelLink] = useState<string>("");
    const [locationCoordinates, setLocationCoordinates] = useState<any>({});

    const isEmpty = (value: any) => value == undefined || value?.trim() === '';

    const getDistributorList = async (modelNumber: any) => {
        try {
            setDistributorList({ loading: true, data: [] });
            const modalRes: any = await userServices.getDistributorList(modelNumber);
            setDistributorList({ loading: false, data: modalRes ?? [] });
        } catch (error) {
            setDistributorList({ loading: false, data: [] });
            console.error('Error while getting distributor list', error);
        }
    }

    const handleChangeDistPopup = (isShow: boolean) => {
        setChangeDistPopup(isShow);
    }

    const getJobTitleList = async () => {
        try {
            setJobTitleList({ loading: true, data: [] });
            const jobTitleRes: any = await userServices.getJobTitleList();
            setJobTitleList({ loading: false, data: jobTitleRes ?? [] });
        } catch (error) {
            setJobTitleList({ loading: false, data: [] });
            console.error('Error while getting job title list', error);
        }
    }

    const getModalNumberList = async () => {
        try {
            setModalNumberList({ loading: true, data: [] });
            const modalRes: any = await userServices.getModalNumberList();
            setModalNumberList({ loading: false, data: modalRes ?? [] });
        } catch (error) {
            setModalNumberList({ loading: false, data: [] });
            console.error('Error while getting modal list', error);
        }
    }

    const getCountryList = async () => {
        try {
            setCountryOptions({ loading: true, data: [] });
            const countryResponse: any = await userServices.getCountryList();
            setCountryOptions({ loading: false, data: countryResponse ?? [] });
        } catch (countryError) {
            setCountryOptions({ loading: false, data: [] });
            console.error('Error while getting country list', countryError);
        }
    }

    const getStateList = async (countryCode: any, formObj: any = {}, selectedObj: any = {}, prevFormData: any = {}) => {
        const form = Object.keys(formObj)?.length ? formObj : formData;
        try {
            setStateOptions({ loading: true, data: [] });
            let stateResponse: any = [];
            let updatedForm = { ...form };
            if (!selectedObj?.adminDistrict) {
                setFormData(updatedForm);
            }
            if (countryCode) {
                stateResponse = await userServices.getStateList(countryCode);
                if (selectedObj?.adminDistrict) {
                    const selectedState = stateResponse?.find((state: any) => state?.name?.toLowerCase() === selectedObj?.adminDistrict?.toLowerCase());
                    updatedForm = { ...updatedForm, state: selectedState?.name, stateCode: selectedState?.id }
                    setFormData(updatedForm);
                }
            }
            if (Object.keys(selectedObj)?.length) {
                setErrors({
                    ...errors,
                    state: updatedForm?.state ? isEmpty(updatedForm?.state) : false,
                    country: updatedForm?.country ? isEmpty(updatedForm?.country) : false,
                    zip: updatedForm?.zip ? isEmpty(updatedForm?.zip) : false,
                    city: updatedForm?.city ? isEmpty(updatedForm?.city) : false,
                    address: updatedForm?.address ? isEmpty(updatedForm?.address) : false
                });
            }
            if (selectedObj?.postalCode && (prevFormData?.zip !== selectedObj?.postalCode)) {
                getCountryFromZip(selectedObj?.postalCode, updatedForm?.modalNumber, updatedForm);
            }
            setStateOptions({ loading: false, data: stateResponse ?? [] });
        } catch (stateError) {
            setFormData({ ...form, state: '', stateCode: '' });
            if (selectedObj?.postalCode && (prevFormData?.zip !== selectedObj?.postalCode)) {
                getCountryFromZip(selectedObj?.postalCode, form?.modalNumber, form);
            }
            if (Object.keys(selectedObj)?.length) {
                setErrors({
                    ...errors,
                    state: form?.state ? isEmpty(form?.state) : false,
                    country: form?.country ? isEmpty(form?.country) : false,
                    zip: form?.zip ? isEmpty(form?.zip) : false,
                    city: form?.city ? isEmpty(form?.city) : false,
                    address: form?.address ? isEmpty(form?.address) : false
                });
            }
            setStateOptions({ loading: false, data: [] });
            console.error('Error while getting state list', stateError);
        }
    }

    const getIPAddress = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return null;
        }
    }

    const getBrowserInfo = () => {
        const browser = Bowser.getParser(window.navigator.userAgent);
        const browserInfo = browser.getBrowser();
        const versionInfo = browser.getBrowserVersion();
        const osInfo = browser.getOS()
        const [majorVersion, minorVersion] = versionInfo.split('.').map(num => parseInt(num, 10));
        const result = {
            type: `${browserInfo.name}${majorVersion}`,
            name: browserInfo.name,
            version: versionInfo,
            majorVersion,
            minorVersion,
            supportsCookies: navigator.cookieEnabled,
            platform: osInfo?.name
        };
        return result;
    }

    const getClientInfo = async () => {
        const ipAddress = await getIPAddress();
        const browserInfo: any = getBrowserInfo();
        setClientInfo({ ...browserInfo, ipAddress });
    };

    const getCurrentPosition = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocationCoordinates(position.coords);
                },
                (error) => {
                    setLocationCoordinates({});
                    helperfunctions.showErrorMessage("Error getting location: " + error.message);
                }
            );
        } else {
            setLocationCoordinates({});
            helperfunctions.showErrorMessage("Geolocation is not supported by this browser.");
        }
    }

    useEffect(() => {
        getCountryList();
        getStateList(formData?.countryCode);
        getModalNumberList();
        getJobTitleList();
        GetMyKomastuBaseUrl();
        getClientInfo();
        GetSocialMediaChannelLink();
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                // Call getCurrentPosition initially
                getCurrentPosition();
                // Listen for changes in the permission state
                result.onchange = () => {
                    getCurrentPosition();
                };
            });
        } else {
            // Fallback if permissions API is not supported
            getCurrentPosition();
        }
        if (isKacApp) {
            getDistributorList(0);
        }
    }, []);

    const GetMyKomastuBaseUrl = () => {
        fetch("/auth/GetMyKomastuBaseURLNoAuth")
            .then((response) => response.json())
            .then((json) => {
                setMyKomastuBaseUrl(json.myKomastuBaseUrl);
            })
            .catch((error) => {
                setMyKomastuBaseUrl("");
            });
    };

    const GetSocialMediaChannelLink = () => {
        fetch("/auth/GetSocialMediaChannelLink")
            .then((response) => response.json())
            .then((json) => {
                setSocialMediaChannelLink(json.socialMediChannelLink);
            })
            .catch((error) => {
                setSocialMediaChannelLink("");
            });
    };

    const getDefaultDistributor = (distributorList: any, checkDistAvailabilityRes: any) => {
        const isMiningMachine = selectedModel?.machineTypeId > 5;
        return distributorList?.data.find((data: any) => {
            const matchedDist = checkDistAvailabilityRes?.data.find((dist: any) => (data?.dbId === dist?.distributorId) && (isMiningMachine ? data?.distributorTypeCode?.toLowerCase() === 'smining' : data?.distributorTypeCode?.toLowerCase() !== 'smining'));
            if (matchedDist) {
                data.available = matchedDist?.available;
                return true;
            }
            return false;
        });
    }

    useEffect(() => {
        if (checkDistAvailabilityRes?.data?.length && Array.isArray(distributorList?.data) && distributorList?.data?.length) {
            const selectedDist = getDefaultDistributor(distributorList, checkDistAvailabilityRes);
            handleDistAvailabilityPopup(!selectedDist?.available);
            setFormData({
                ...formData,
                distributor: selectedDist?.name,
                distributorId: selectedDist?.dbId,
                distributorTypeCode: selectedDist?.distributorTypeCode,
            });
            if (errors?.distributor) {
                setErrors({ ...errors, distributor: isEmpty(selectedDist?.name) });
            }
        } else if (!checkDistAvailabilityRes?.data?.length && Array.isArray(distributorList?.data) && distributorList?.data?.length) {
            setFormData({
                ...formData,
                distributor: '',
                distributorId: '',
                distributorTypeCode: '',
            });
        }
    }, [checkDistAvailabilityRes?.data, distributorList?.data]);

    const handleChange = (e: any) => {
        const { name, value = '' } = e?.target || {};
        const inputValue = value;
        const formDataObj = { ...formData };

        setErrors({
            ...errors,
            [name]: false,
        });
        if (name === 'email' && submitResponse?.data?.userExists) {
            setSubmitResponse({ loading: false, data: {} });
        } else if (name === 'zip') {
            if (inputValue.length > 4) {
                const zipCode = inputValue.length > 9 ? formData?.zip : inputValue
                getCountryFromZip(zipCode, formData?.modalNumber);
            }
            if (!inputValue && formDataObj?.distributor) {
                formDataObj.distributor = '';
                formDataObj.distributorId = '';
                formDataObj.distributorTypeCode = '';
            }
        }
        setFormData({
            ...formDataObj,
            [name]: (name === 'zip' && inputValue.length > 9) ? formDataObj?.zip : inputValue,
        });
    };

    const handleDropdownChange = (name: string, value: any, extra: any) => {
        const formDataObj = { ...formData };
        const selectedDist = getDefaultDistributor(distributorList, checkDistAvailabilityRes);
        if (name === 'country') {
            formDataObj.state = '';
        }
        setErrors({
            ...errors,
            [name]: false,
        });
        if (name === 'country') {
            getStateList(extra?.countryCode, {
                ...formDataObj,
                [name]: value,
                ...((name === 'country' || name === 'state') ? { [`${name}Code`]: extra?.[`${name}Code`] } : {}),
            });
        } else if (name === 'distributor' && selectedDist?.name) {
            handleChangeDistPopup(true);
            setSelectedDistBeforeConfirm(extra);
        } else if (name === 'modalNumber') {
            getDistributorList(isKacApp ? 0 : extra?.id);
            formDataObj.modalId = extra?.id;
            if(!value){
                formDataObj.distributorId = '';
                formDataObj.distributorTypeCode = '';
                formDataObj.distributor = '';
                if(!isKacApp) {
                    formDataObj.serialNumber = '';
                }
            }
            setSelectedModel(extra);
        }
        if (name != 'country' && (name !== 'distributor' || !selectedDist?.name)) {
            if (name === 'distributor') {
                formDataObj.distributorId = extra?.dbId;
                formDataObj.distributorTypeCode = extra?.distributorTypeCode;
            }
            setFormData({
                ...formDataObj,
                [name]: value,
                ...((name === 'country' || name === 'state') ? { [`${name}Code`]: extra?.[`${name}Code`] } : {}),
            });
        }
    };

    const onCheckActivation = () => {
        if (myKomastuBaseUrl) {
            window.location.href = myKomastuBaseUrl + '/Home/RegistrationStatus'
        }
    }

    const formatBrowserInfo = (clientInfo: any) => {
        return `Browser Capabilities Type = ${clientInfo.type} Name = ${clientInfo.name} Version = ${clientInfo.version} Major Version = ${clientInfo.majorVersion} Minor Version = ${clientInfo.minorVersion} Platform = ${clientInfo.platform} Supports Cookies = ${clientInfo.supportsCookies ? 'True' : 'False'}`;
    }

    const onSubmit = async () => {
        try {
            setSubmitResponse({ loading: true, data: {} });
            const reqBody = {
                "businessName": formData?.companyName,
                "firstName": formData?.firstName,
                "lastName": formData?.lastName,
                "email": formData?.email,
                "phone": formData?.phoneNumber,
                "title": formData?.jobTitle,
                "address1": formData?.address,
                "city": formData?.city,
                "country": formData?.countryCode,
                "state": formData?.stateCode,
                "zipCode": formData?.zip,
                "model": formData?.modalNumber,
                "serial": formData?.serialNumber,
                "distributorId": formData?.distributorId,
                "invitationMode": formData?.isSendInvitation ? 2 : 1, //1-Email 2-Sms
                "distributorTypeCode": formData?.distributorTypeCode,
                "iPAddress": clientInfo?.ipAddress,
                "browserInfo": formatBrowserInfo(clientInfo),
                "applicationName": applicationName,
                "redirectURL": redirecturl
            }
            const response: any = await userServices.submitUserRegistration(reqBody);
            setSubmitResponse({ loading: false, data: response });
            if (response?.isSuccess && !response?.userExists) {
                handleSubmitPopup(true);
                if (response?.distributorEMails && formData?.distributorTypeCode?.toLowerCase() !== 'smining') {
                    sendNotification(response)
                }
            }
            if (response?.validationMessage && !response?.userExists) {
                helperfunctions.showErrorMessage(`${response?.validationMessage}`);
            }
            if (response?.userExists) {
                if (containerRef.current) {
                    containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }
        } catch (error) {
            console.error('Error while submitting the form', error);
            helperfunctions.showErrorMessage(`${error}`);
            setSubmitResponse({ loading: false, data: {} });
        }
    }

    const onSubmitForm = async () => {
        const isValidEmail = helperfunctions.validEmailCheck(formData?.email?.trim());
        const isValidPhone = helperfunctions.validPhoneCheck(formData?.phoneNumber?.trim());
        const newReqErrors = {
            firstName: isEmpty(formData?.firstName),
            lastName: isEmpty(formData?.lastName),
            email: isEmpty(formData?.email) || !isValidEmail,
            phoneNumber: isEmpty(formData?.phoneNumber) || !isValidPhone,
            jobTitle: isEmpty(formData?.jobTitle),
            companyName: isEmpty(formData?.companyName),
            city: isEmpty(formData?.city),
            zip: isEmpty(formData?.zip),
            address: isEmpty(formData?.address),
            state: isEmpty(formData?.state),
            country: isEmpty(formData?.country),
            modalNumber: isKacApp ? false : isEmpty(formData?.modalNumber),
            distributor: isEmpty(formData?.distributor),
            isInValidEmail: !isValidEmail,
            isInValidPhone: !isValidPhone,
        };
        const errorObj = {
            ...newReqErrors,
            isAgreeTerms: !formData?.isAgreeTerms,
            serialNumber: (isKacApp) ? false : (isEmpty(formData?.serialNumber)),
        }
        setErrors({ ...newReqErrors, ...errorObj });
        const hasErrors = Object.values(newReqErrors).some(error => error);
        const hasOtherErrors = Object.values(errorObj).some(error => error);

        if (hasErrors || hasOtherErrors) {
            setIsShowReqError(true);
            if (containerRef.current) {
                containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
        if (formData?.email && !isValidEmail) {
            setErrorSuccessMessage('Please enter a valid email address.');
        } else if (formData?.phoneNumber && !isValidPhone) {
            setErrorSuccessMessage('Please enter a valid phone number.');
        } else if (hasErrors) {
            setErrorSuccessMessage('Please fill all mandatory fields before submitting.');
        } else if ((!isKacApp && !formData?.serialNumber)) {
            setErrorSuccessMessage('Please enter the serial number from one machine in your fleet.');
        } else if (errorObj?.isAgreeTerms) {
            setErrorSuccessMessage('Please agree to the Terms of Use.');
        } else {
            onSubmit();
            setErrorSuccessMessage('');
            setIsShowReqError(false);
        }
    }

    const handleAlertClose = () => {
        setIsShowReqError(false);
        setErrorSuccessMessage('');
    }

    const onClickLogin = () => {
        window.location.href = `/auth/index?returnUrl=`;
    }

    const handleDistAvailabilityPopup = (isShow: boolean) => {
        setShowDistributorAvailabilityPopUp(isShow);
    }

    const handleSubmitPopup = (isShow: boolean, isOk: boolean = false) => {
        setSubmitAlert(isShow);
        if (isOk) {
            window.location.href = redirecturl || (myKomastuBaseUrl + '/Home');
        }
    }

    const checkDistributorAvailability = async (zipCode: any, modalNumber: any, formObj: any = null, locality: any) => {
        try {
            setCheckDistAvailabilityRes({ loading: true, data: [] });
            const response: any = await userServices.checkDistributorAvailability({
                county: locality,
                type: 'selfregistration'
            });
            const data = formObj || formData;
            setFormData({
                ...data,
                zip: zipCode,
                modalNumber
            });
            setCheckDistAvailabilityRes({ loading: false, data: response });
        } catch (error) {
            console.error('Error while submitting the form', error);
            setCheckDistAvailabilityRes({ loading: false, data: [] });
        }
    }

    const getCountryFromZip = async (zipCode: any, modalNumber: any, formObj: any = null) => {
        try {
            setCountryFromZipRes({ loading: true, data: {} });
            const response: any = await userServices.getCountryFromZip(zipCode);
            if (response?.isSuccessful) {
                if (response?.locality) {
                    checkDistributorAvailability(zipCode, modalNumber, formObj, response?.locality);
                } else {
                    setCheckDistAvailabilityRes({ loading: false, data: [] });
                    handleDistAvailabilityPopup(true);
                }
            } else {
                setCheckDistAvailabilityRes({ loading: false, data: [] });
                handleDistAvailabilityPopup(true);
                console.error('Error while get Country From Zip', response);
            }
            setCountryFromZipRes({ loading: false, data: response });
        } catch (error) {
            setCheckDistAvailabilityRes({ loading: false, data: [] });
            handleDistAvailabilityPopup(true);
            setCountryFromZipRes({ loading: false, data: {} });
            console.error('Error while get Country From Zip', error);
        }
    }

    const onBlurZipCode = (e: any) => {
        let zipCode = e?.target?.value?.trim() || '';
        if (zipCode && zipCode.length <= 4) {
            zipCode = zipCode?.length > 9 ? zipCode.slice(0, 9) : zipCode;
            getCountryFromZip(zipCode, formData?.modalNumber);
        }
    }

    const onCloseAddress = (event: any) => {
        const value = event?.value || '';
        if (value) {
            const selectedObj = addressList?.data?.find((address: any) => address?.addressLine === value);
            setFormData({ ...formData, address: selectedObj?.addressLine ? selectedObj?.addressLine?.trim() : value?.trim() });
            setSelectedAddress(selectedObj);
            if (selectedObj?.addressLine) {
                const selectedCountry = selectedObj?.countryRegion ? countryOptions?.data?.find((country: any) => country?.countryCode?.toLowerCase() === selectedObj?.countryRegionIso2?.toLowerCase()) : {};
                const formObj = {
                    ...formData,
                    address: selectedObj?.addressLine,
                    city: selectedObj?.locality,
                    zip: selectedObj?.postalCode,
                    country: selectedCountry?.country,
                    countryCode: selectedCountry?.countryCode,
                };
                getStateList(selectedObj?.countryRegionIso2, formObj, selectedObj, formData);
            }
        }
    }

    function formatAddressList(addressList: any) {
        return addressList.map((address: any) => {
            if (address?.address) {
                return { ...address?.address };
            }
        });
    }

    const getCoordinates = () => {
        const { latitude, longitude } = locationCoordinates;
        const coordinates = (latitude && longitude) ? `${locationCoordinates.latitude},${locationCoordinates.longitude},100` : undefined;
        return coordinates;
    }

    const onChangeAddress = async (event: any) => {
        try {
            const value = event?.value || '';
            setFormData({ ...formData, address: value });
            setErrors({ ...errors, address: value ? false : errors?.address });
            if (value) {
                setAddressList({ loading: true, data: [] });
                setSelectedAddress({});
                const response: any = await userServices.getAddressList(value, getCoordinates());
                const addresses = formatAddressList(response?.resourceSets?.[0]?.resources?.[0]?.value);
                setAddressList({ loading: false, data: addresses ?? [] });
            }
        } catch (error) {
            setAddressList({ loading: false, data: [] });
            console.error('Error while getting address list', error);
        }
    };

    const onBlurAddress = () => {
        setAddressList({ loading: false, data: [] });
    }

    const onFocusAddress = async () => {
        try {
            if (formData?.address) {
                setAddressList({ loading: true, data: [] });
                setSelectedAddress({});
                const response: any = await userServices.getAddressList(formData?.address, getCoordinates());
                const addresses = formatAddressList(response?.resourceSets?.[0]?.resources?.[0]?.value);
                setAddressList({ loading: false, data: addresses ?? [] });
            }
        } catch (error) {
            setAddressList({ loading: false, data: [] });
            console.error('Error while getting address list', error);
        }
    }

    const onPopUpBtnClick = (isYes: boolean) => {
        if (isYes) {
            setFormData({
                ...formData,
                distributor: selectedDistBeforeConfirm?.name,
                distributorId: selectedDistBeforeConfirm?.dbId,
                distributorTypeCode: selectedDistBeforeConfirm?.distributorTypeCode,
            });
            setSelectedDistBeforeConfirm({});
            handleChangeDistPopup(false);
        } else {
            handleChangeDistPopup(false);
        }
    }

    const sendNotification = async (submitRes: any) => {
        try {
            setNotificationResponse({ loading: true, isSuccess: '' });
            const reqBody = {
                "businessName": formData?.companyName,
                "firstName": formData?.firstName,
                "lastName": formData?.lastName,
                "email": formData?.email,
                "distributorName": submitRes?.distributorName ?? '',
                "distributorEmails": submitRes?.distributorEMails,
                "phoneNo": formData?.phoneNumber,
                "address": formData?.address,
                "city": formData?.city,
                "countryName": formData?.countryCode,
                "stateName": formData?.stateCode,
                "zipCode": formData?.zip,
                "distributorTypeCode": formData?.distributorTypeCode ?? '',
            }
            const response: any = await userServices.sendNotification(reqBody);
            setNotificationResponse({ loading: false, isSuccess: response });
        } catch (error) {
            setNotificationResponse({ loading: false, isSuccess: false });
            console.error('Error while sending notification', error);
        }
    }

    const onTermsClick = () => {
        if (myKomastuBaseUrl) {
            window.open(myKomastuBaseUrl + '/MyProfile/GetConsentForm?mode=read', '_blank');
        }
    }

    const handleCloseConfirmation = (isOk: boolean = false) => {
        setCloseConfirmation(false);
        if (isOk) {
            window.location.href = myKomastuBaseUrl + '/Home';
        }
    }

    const onClose = () => {
        setCloseConfirmation(true);
    }

    const onSocialMediaLogoClick = () => {
        if (socialMediaChannelLink) {
            window.open(socialMediaChannelLink, '_blank');
        }
    }
    
    return (
        <UserRegistration
            formData={formData}
            errors={errors}
            jobTitleList={jobTitleList}
            stateOptions={stateOptions}
            distributorList={distributorList}
            countryOptions={countryOptions}
            handleChange={handleChange}
            handleDropdownChange={handleDropdownChange}
            onCheckActivation={onCheckActivation}
            onSubmitForm={onSubmitForm}
            errorSuccessMessage={errorSuccessMessage}
            isShowReqError={isShowReqError}
            handleAlertClose={handleAlertClose}
            submitResponse={submitResponse}
            onClickLogin={onClickLogin}
            countryFromZipRes={countryFromZipRes}
            onBlurZipCode={onBlurZipCode}
            showDistributorAvailabilityPopUp={showDistributorAvailabilityPopUp}
            checkDistAvailabilityRes={checkDistAvailabilityRes}
            handleDistAvailabilityPopup={handleDistAvailabilityPopup}
            modalNumberList={modalNumberList}
            onChangeAddress={onChangeAddress}
            addressList={addressList}
            onBlurAddress={onBlurAddress}
            selectedAddress={selectedAddress}
            changeDistPopup={changeDistPopup}
            handleChangeDistPopup={handleChangeDistPopup}
            onPopUpBtnClick={onPopUpBtnClick}
            onCloseAddress={onCloseAddress}
            onFocusAddress={onFocusAddress}
            submitAlert={submitAlert}
            handleSubmitPopup={handleSubmitPopup}
            containerRef={containerRef}
            notificationResponse={notificationResponse}
            onTermsClick={onTermsClick}
            onClose={onClose}
            handleCloseConfirmation={handleCloseConfirmation}
            closeConfirmation={closeConfirmation}
            onSocialMediaLogoClick={onSocialMediaLogoClick}
            isKacApp={isKacApp}
        />
    );
};

export default UserRegistrationContainer;